import { render, staticRenderFns } from "./WxCheckboxWeekdays.vue?vue&type=template&id=6214ca39&scoped=true"
import script from "./WxCheckboxWeekdays.vue?vue&type=script&lang=js"
export * from "./WxCheckboxWeekdays.vue?vue&type=script&lang=js"
import style0 from "./WxCheckboxWeekdays.vue?vue&type=style&index=0&id=6214ca39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6214ca39",
  null
  
)

export default component.exports